<template>
  <div>
    <a-modal
      width="80%"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :destroyOnClose="true"
      @ok="handleOk"
      @cancel="handleCancel"
      :footer="null"
    >
      <!-- <video
        style="width: 100%"
        controls=""
        preload="auto"
        poster="https://www.chuf.com/assets/img/o_nas/nahled-video.webp"
      >
        <source :src="imgs[0]" type="video/mp4" />
      </video> -->
      <video
        ref="videoPlayer"
        id="video1"
        v-show="imgs.length > 0"
        controls
        width="99%"
      >
        <source :src="imgs[0]" type="video/mp4" />
      </video>
      <!-- <p>{{ imgs[0] }}</p> -->
    </a-modal>
  </div>
</template>

<script>
import { getBucket } from "../utils/util";

export default {
  data() {
    return {
      ModalText: "",
      visible: false,
      confirmLoading: false,
      imgs: [],
    };
  },
  comments: {},
  methods: {
    async getImg(addr, id) {
      this.imgs = await getBucket(addr, id);
      if (this.imgs.length == 0) {
        this.$message.info("当前车辆没有上传视频!!");
      }
      console.log("getimg");
    },
    async show(data) {
      await this.getImg("basicVideo/", data.id);
      // this.$message.success(this.imgs[0]);
      if (this.imgs.length > 0) {
        this.visible = true;
        setTimeout(() => {
          const videoElement = this.$refs;
          console.log(this.$refs, "1");
          // debugger;
          const videoPlayer = videoElement.videoPlayer;
          videoPlayer.requestFullscreen();
        }, 500);
      }
    },
    handleOk(e) {
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel(e) {
      this.visible = false;
    },
  },
};
</script>

<style scoped></style>
